import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PriceEstimateBreakdownPipe } from '../../../shared/pipes/price-estimate-breakdown.pipe';
import { HlCurrencyPipe } from '../../../shared/pipes/hl-currency.pipe';

@Component({
  selector: 'app-charge-display',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatTooltipModule,
    PriceEstimateBreakdownPipe,
    HlCurrencyPipe
  ],
  templateUrl: './charge-display.component.html',
  styleUrls: ['./charge-display.component.css']
})
export class ChargeDisplayComponent implements OnInit {
  @Input() item: any;
  @Input() currencyCode: string = 'GBP';
  @Input() conversionRate: number = 1;

  reviewStatus: 'success' | 'warning' | 'error' | null = null;
  reviewMessage: string = '';

  constructor() {}

  ngOnInit(): void {
    this.determineReviewStatus();
  }

  private determineReviewStatus(): void {
    const fixedCharge = this.item.charge;
    const suggestedPrice = this.item.suggested_price;

    // Case 1: Auto-calculation failed
    if (suggestedPrice?.error) {
      this.reviewStatus = 'error';
      this.reviewMessage = `Auto-calculation failed: ${suggestedPrice.error}`;
      return;
    }

    // Case 2: Fixed price exists but differs from auto-calculated price
    if (fixedCharge !== null && suggestedPrice?.estimate) {
      const autoCalculatedValue = suggestedPrice.estimate.price;
      const difference = Math.abs(fixedCharge - autoCalculatedValue);
      const percentDifference = (difference / autoCalculatedValue) * 100;

      if (difference > 0.01) {
        // Allow for small rounding differences
        this.reviewStatus = 'warning';
        this.reviewMessage = `Fixed price (${fixedCharge.toFixed(2)}) differs from auto-calculated price (${autoCalculatedValue.toFixed(2)}) by ${percentDifference.toFixed(2)}%`;
      } else {
        this.reviewStatus = 'success';
        this.reviewMessage = 'Fixed price matches auto-calculated price';
      }
      return;
    }

    // Case 3: Fixed price exists but no auto-calculation
    if (fixedCharge !== null && !suggestedPrice?.estimate) {
      this.reviewStatus = 'warning';
      this.reviewMessage = 'Using fixed price, auto-calculation not available';
      return;
    }

    // Case 4: No fixed price but auto-calculation successful
    if (fixedCharge === null && suggestedPrice?.estimate) {
      this.reviewStatus = 'success';
      this.reviewMessage = 'Using auto-calculated price';
      return;
    }

    // Case 5: No fixed price and no auto-calculation
    this.reviewStatus = 'error';
    this.reviewMessage = 'No pricing information available';
  }

  get displayValue(): number | null {
    return this.item.charge !== null
      ? this.item.charge
      : this.item.suggested_price?.estimate?.price
        ? this.item.suggested_price.estimate.price
        : null;
  }
}
